import { useSectorMark } from '@hooks/useSectorMarkHook';

export const use_ROLESECTOR_COLUMNS = () => {
  const sectorMark = useSectorMark();
  return [
    {
      title: '姓名',
      dataIndex: 'realName',
      key: 'realName'
    },
    {
      title: sectorMark,
      dataIndex: 'userTypesName',
      key: 'userTypesName'
    },
    {
      title: '手机号码',
      dataIndex: 'mobile',
      key: 'mobile'
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email'
    }
  ];
};
